/* eslint-disable react/prop-types */
import React from "react";
import { Link, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UserDashboardHeader = (props) => {
  const location = useLocation();
  let pathname = location.pathname;

  const { t } = useTranslation();

  return (
    <div className="card">
      <div className="card-body">
        <ul className="nav nav-tabs nav-tabs-solid nav-justified">
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("user-dashboard") ? "active" : ""
              }`}
              to="/user-dashboard"
            >
              Dashboard
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("user-all-jobs") ? "active" : ""
              }`}
              to="/user-all-jobs"
            >
              {t('All')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("saved-jobs") ? "active" : ""
              }`}
              to="/saved-jobs"
            >
              {t('Saved')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("applied-jobs") ? "active" : ""
              }`}
              to="/applied-jobs"
            >
              {t('Applied')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname === "/interviewing" ||
                pathname.includes("job-aptitude") ||
                pathname.includes("questions")
                  ? "active"
                  : ""
              }`}
              to="/interviewing"
            >
              {t('Interviewing')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("offered-jobs") ? "active" : ""
              }`}
              to="/offered-jobs"
            >
              {t('Offered')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("visited-jobs") ? "active" : ""
              }`}
              to="/visited-jobs"
            >
              {t('Visitied')}
            </Link>
          </li>
          <li className="nav-item">
            <Link
              className={`nav-link ${
                pathname.includes("archived-jobs") ? "active" : ""
              }`}
              to="/archived-jobs"
            >
              {t('Archived')}
            </Link>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default UserDashboardHeader;
